import { useTranslation } from "react-i18next";

interface AppUpdatePromptProps {
    isUpdateAvailable: boolean;
}

function useAppUpdatePrompt(props: AppUpdatePromptProps) {
    const { t } = useTranslation();

    return {
        state: {
            isVisible: props.isUpdateAvailable,
            message: t('APP_UPDATE_Message'),
            buttonLabel: t('APP_UPDATE_RefreshButton'),
        },
        handlers: {
            onRefresh: () => window.location.reload(),
        },
    };
}

export default function AppUpdatePrompt(props: AppUpdatePromptProps) {
    const { state, handlers } = useAppUpdatePrompt(props);

    if (!state.isVisible) return null;

    return (
        <div
            className="alert alert-warning d-flex align-items-center justify-content-between mb-0 px-3 py-2 position-fixed top-0 start-0 end-0"
            style={{ zIndex: 9999 }}
            role="alert"
        >
            <span>{state.message}</span>
            <button
                type="button"
                className="btn btn-warning btn-sm ms-3 flex-shrink-0"
                onClick={handlers.onRefresh}
            >
                {state.buttonLabel}
            </button>
        </div>
    );
}
